import { DropdownSelect } from "@jasper/forms";
import { useState } from "react";
import { Text, Button } from "@mantine/core";
import { IntegrationType } from "@jasper/client-models";

export const ExternalCaseDentistSelection = ({
  selectedCase,
  dentistList,
  onSubmit,
}: {
  selectedCase: {
    id: string;
    patient: string;
    externalEmail?: string | null;
    integrationType: IntegrationType;
  } | null;
  dentistList: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    isManager: boolean;
  }[];
  onSubmit: ({
    selectedCaseId,
    dentistId,
  }: {
    selectedCaseId: string;
    dentistId: string;
  }) => void;
}) => {
  const [selectedDentistId, setSelectedDentistId] = useState<
    string | undefined
  >(undefined);

  if (!selectedCase) {
    return null;
  }

  return (
    <>
      <Text>
        <span style={{ fontWeight: "bold" }}>Case:</span> {selectedCase.id}
      </Text>
      <Text>
        <span style={{ fontWeight: "bold" }}>Patient:</span>{" "}
        {selectedCase.patient}
      </Text>
      <Text>
        <span style={{ fontWeight: "bold" }}>External email:</span>{" "}
        {selectedCase.externalEmail}
      </Text>
      <Text>
        <span style={{ fontWeight: "bold" }}>Integration:</span>{" "}
        {selectedCase.integrationType}
      </Text>
      <hr />
      <DropdownSelect
        data={dentistList.map(dentist => ({
          value: dentist.id,
          label: `${dentist.firstName} ${dentist.lastName} - ${dentist.email} ${dentist.isManager ? "(MASTER ACCOUNT)" : ""}`,
        }))}
        label="Select a dentist"
        onChange={(value: string) => setSelectedDentistId(value)}
      />
      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        <Button
          onClick={() =>
            selectedDentistId &&
            onSubmit({
              selectedCaseId: selectedCase.id,
              dentistId: selectedDentistId,
            })
          }
        >
          Submit
        </Button>
      </div>
    </>
  );
};
